import React, { useContext, useMemo } from 'react';
import ActionTypes from '@utils/deviceActions';
import { Divider, Form, FormInstance } from 'antd';
import { useTranslation } from 'react-i18next';
import { IDevice } from '@pages/Assets/Inventory/types';
import SessionContext from '@providers/Session/SessionContext';
import { DeviceActionProps } from '@components/Actions/ActionsModal/types';
import CustomTag from '@components/CustomTag';

interface ActivationMotPayloadProps {
  action: ActionTypes.ACTIVATION_MOT;
  contractId: string;
  devices: {
    iccid: string;
    msisdn: string;
    imsi: string;
    vendor: string;
  }[];
}

interface ActivationMotProps {
  devices: IDevice[];
  form: FormInstance<any>;
}

const useActivationMot = ({
  devices,
  form,
}: ActivationMotProps): DeviceActionProps => {
  const { t } = useTranslation('actions-modal');
  const { motOperators } = useContext(SessionContext);
  const contractId = Form.useWatch('contractId', form);

  const uploadCustomInfo = useMemo(
    () => (
      <div style={{ opacity: 0.9, textAlign: 'center' }}>
        <Divider style={{ fontSize: '0.9rem', opacity: 0.9, marginTop: 0 }}>
          {t('simcard-import.carriers-available')}
        </Divider>
        {motOperators?.map((operatorName: string) => (
          <CustomTag key={operatorName}>{operatorName}</CustomTag>
        ))}
      </div>
    ),
    [motOperators, t],
  );

  const payloadToSend = useMemo(
    (): ActivationMotPayloadProps => ({
      action: ActionTypes.ACTIVATION_MOT,
      contractId,
      devices: devices?.map(device => ({
        msisdn: device.msisdn,
        iccid: device.iccid,
        imsi: device.imsi,
        vendor: device.vendor ?? '',
      })),
    }),
    [contractId, devices],
  );

  return {
    steps: [],
    uploadCustomInfo,
    payloadToSend,
  };
};

export default useActivationMot;
